import { SVGProps, useContext } from "react"
import { CanvasControlsContext } from "@/components/canvas-controls/CanvasControlsContext"

interface LineProps extends SVGProps<SVGLineElement> {
	x1: number
	y1: number
	x2: number
	y2: number
	angle?: number
}

export const Line = ({ x1, y1, x2, y2, angle = 0, ...props }: LineProps) => {
	const { parentX, parentY, parentWidth, parentHeight } = useContext(CanvasControlsContext)

	x1 = parentX + x1 * parentWidth
	y1 = parentY + y1 * parentHeight
	x2 = parentX + x2 * parentWidth
	y2 = parentY + y2 * parentHeight

	const transform = angle
		? `rotate(${-angle} ${x1 * 0.5 + x2 * 0.5} ${y1 * 0.5 + y2 * 0.5})`
		: `none`

	return (
		<g transform={transform}>
			<line
				x1={x1}
				y1={y1}
				x2={x2}
				y2={y2}
				stroke="rgba(0,0,0,0.3)"
				strokeWidth={3}
				className="pointer-events-none"
			/>
			<line
				x1={x1}
				y1={y1}
				x2={x2}
				y2={y2}
				stroke="white"
				strokeWidth={1}
				className="pointer-events-none"
				{...props}
			/>
		</g>
	)
}
